import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * Styled markdown renderer for help drawer articles.
 */
export default function HelpMarkdown({ children }) {
  return (
    <div className="help-markdown prose prose-sm max-w-none text-gray-800">
      <ReactMarkdown
        components={{
          h1: ({ node, ...props }) => (
            <h1 className="text-xl font-bold text-gray-900 mt-0 mb-3" {...props} />
          ),
          h2: ({ node, ...props }) => (
            <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2 border-b border-gray-200 pb-1" {...props} />
          ),
          h3: ({ node, ...props }) => (
            <h3 className="text-base font-semibold text-gray-800 mt-4 mb-2" {...props} />
          ),
          p: ({ node, ...props }) => <p className="text-sm leading-relaxed mb-3 text-gray-700" {...props} />,
          ul: ({ node, ...props }) => <ul className="list-disc pl-5 mb-3 space-y-1 text-sm text-gray-700" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal pl-5 mb-3 space-y-1 text-sm text-gray-700" {...props} />,
          li: ({ node, ...props }) => <li className="leading-relaxed" {...props} />,
          strong: ({ node, ...props }) => <strong className="font-semibold text-gray-900" {...props} />,
          code: ({ node, className, children, ...props }) => {
            const isBlock = Boolean(className) || String(children).includes('\n');
            if (isBlock) {
              return (
                <code
                  className={`block p-3 rounded bg-gray-100 text-xs font-mono overflow-x-auto mb-3 ${className || ''}`}
                  {...props}
                >
                  {children}
                </code>
              );
            }
            return (
              <code className="px-1 py-0.5 rounded bg-gray-100 text-xs font-mono text-gray-800" {...props}>
                {children}
              </code>
            );
          },
          a: ({ node, ...props }) => (
            <a className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer" {...props} />
          ),
        }}
      >
        {children || ''}
      </ReactMarkdown>
    </div>
  );
}
